import { render, staticRenderFns } from "./CurrentOffers.vue?vue&type=template&id=5e25e420&scoped=true"
import script from "./CurrentOffers.vue?vue&type=script&lang=js"
export * from "./CurrentOffers.vue?vue&type=script&lang=js"
import style0 from "./CurrentOffers.vue?vue&type=style&index=0&id=5e25e420&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e25e420",
  null
  
)

export default component.exports